import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import LandingPage from './LandingPage';
import Demo from './Demo';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import ClientLogin from './client/ClientLogin';
import ClientDashboard from './client/ClientDashboard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/parsingmodel" element={<ClientLogin />} />
        <Route path="/parsingmodel/dashboard" element={<ClientDashboard />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
